import React, { useEffect, useRef, useState } from "react";
import { Wrapper, ContentTypeRender } from "nystem-components";

const BootstrapCssClassByVal = ({ model, path, value, view }) => {
  const { condition, item, className, pointerClassName } = model;
  const ref = useRef();
  const [pointerOver, setPointerOver] = useState(false);
  const [playerPointerOver, setPlayerPointerOver] = useState(false);

  useEffect(() => {
    if (!pointerClassName) return;
    const onWindowLeave = (event) => {
      if (event.relatedTarget !== null) return;
      setPointerOver(false);
      setPlayerPointerOver(false);
    };
    const onPlayerPointer = ({ pointerOver, clientX, clientY }) => {
      const bounds = ref.current?.getBoundingClientRect();
      setPlayerPointerOver(
        Boolean(
          pointerOver &&
          bounds &&
          clientX >= bounds.left &&
          clientX < bounds.right &&
          clientY >= bounds.top &&
          clientY < bounds.bottom,
        ),
      );
    };
    view.on("playerPointer", onPlayerPointer);
    document.addEventListener("pointerout", onWindowLeave);
    document.addEventListener("mouseleave", onWindowLeave);
    return () => {
      view.off("playerPointer", onPlayerPointer);
      document.removeEventListener("pointerout", onWindowLeave);
      document.removeEventListener("mouseleave", onWindowLeave);
    };
  }, [view, pointerClassName]);

  const getClass = (value) => {
    const addClass = [];
    // 0-field, 1-vlaue, 2-cssClass
    for (let i = 0; condition && i < condition.length; i++)
      if (value[condition[i][0]] === condition[i][1]) addClass.push(condition[i][2]);
    return ` ${addClass.join(" ")}`;
  };

  const addClass = getClass(value);

  return (
    <Wrapper
      ref={ref}
      className={[...className, addClass, (pointerOver || playerPointerOver) && pointerClassName]}
      onPointerEnter={pointerClassName ? () => setPointerOver(true) : undefined}
      onPointerLeave={
        pointerClassName
          ? () => {
              setPointerOver(false);
              setPlayerPointerOver(false);
            }
          : undefined
      }
    >
      <ContentTypeRender path={path} items={item} />
    </Wrapper>
  );
};

export default BootstrapCssClassByVal;
